import React from "react";

import LoaderContainer from "./LoaderContainer";
import LoadingSpinner2 from "./LoadingSpinner2";

function LoadingFallback({ size = 2, thickness = 0.13, style }) {
  return (
    <LoaderContainer style={{ ...style }}>
      <LoadingSpinner2 size={size} thickness={thickness} />
    </LoaderContainer>
  );
}

export default LoadingFallback;
